// extracted by mini-css-extract-plugin
module.exports = {"container":"CityLink_container__t6Oif","icon":"CityLink_icon__4m0iQ"};